import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { DropdownMenu, IconButton, Typography, useStateInRef } from 'seagull';
import { TrashLine, Edit2Liner18, MoreVertical, CopyLiner24 } from 'seagull/icons';
import styles from "./ServicePackages.module.scss";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
const tabPanelId = 'services-in-pkg';
export default function ServicePackagesTab(props) {
  const {
    bundle,
    isSelected,
    testid,
    bundlesCount,
    onClick,
    onRemove,
    onChangeName,
    onDuplicate: handleDuplicate
  } = props;
  const getProps = useStateInRef(props);
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedName, setEditedName] = useState(bundle.name);
  const inputRef = useRef();
  const {
    DUPLICATE_PACKAGE
  } = useFeatureFlags();
  useEffect(() => {
    if (isEditingName) {
      const cancelEditOnEscapeKey = e => {
        if (e.key === 'Escape') {
          setEditedName(getProps().bundle.name);
          setIsEditingName(false);
        }
      };

      window.addEventListener('keydown', cancelEditOnEscapeKey);
      return () => window.removeEventListener('keydown', cancelEditOnEscapeKey);
    }
  }, [isEditingName]);

  const applyEdit = () => {
    onChangeName(editedName.trim(), bundle.id);
    setIsEditingName(false);
  };

  return /*#__PURE__*/React.createElement("button", {
    key: bundle.id,
    role: "tab",
    className: cn(styles.tab, {
      [styles.editing]: isEditingName
    }),
    "aria-selected": isSelected ? 'true' : 'false',
    "aria-controls": tabPanelId,
    "data-testid": testid,
    onClick: function (_onClick3) {
      function onClick() {
        return _onClick3.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick3.toString();
      };

      return onClick;
    }(() => onClick(bundle.id))
  }, isEditingName ? /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      applyEdit();
    },
    className: styles.form
  }, /*#__PURE__*/React.createElement(Typography, {
    as: "input",
    ref: inputRef,
    className: styles.nameInput,
    "data-testid": "".concat(testid, "-input"),
    value: editedName,
    onChange: e => setEditedName(e.target.value),
    onBlur: () => applyEdit()
  })) : /*#__PURE__*/React.createElement(Typography, {
    ellipsis: true
  }, bundle.name), !isEditingName && /*#__PURE__*/React.createElement(DropdownMenu, {
    onClose: (anchorEl, reason, event) => event.stopPropagation(),
    target: /*#__PURE__*/React.createElement(IconButton, {
      noPadding: true,
      skin: "transparent",
      size: "small",
      "data-testid": "".concat(testid, "-dropdown"),
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement(MoreVertical, null))
  }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    iconStart: /*#__PURE__*/React.createElement("div", {
      className: styles.iconContainer
    }, /*#__PURE__*/React.createElement(Edit2Liner18, null)),
    "data-testid": "".concat(testid, "-edit"),
    onClick: function (_onClick) {
      function onClick(_x) {
        return _onClick.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick.toString();
      };

      return onClick;
    }(e => {
      e.stopPropagation();
      onClick(bundle.id);
      setIsEditingName(true);
      setTimeout(() => inputRef.current.focus());
    })
  }, "Rename"), bundlesCount < 3 && DUPLICATE_PACKAGE && /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    iconStart: /*#__PURE__*/React.createElement(CopyLiner24, null),
    "data-testid": "".concat(testid, "-duplicate"),
    onClick: e => {
      e.stopPropagation();
      handleDuplicate(bundle);
    }
  }, "Duplicate"), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    skin: "error",
    "data-testid": "".concat(testid, "-remove"),
    iconStart: /*#__PURE__*/React.createElement("div", {
      className: styles.iconContainer
    }, /*#__PURE__*/React.createElement(TrashLine, null)),
    onClick: function (_onClick2) {
      function onClick(_x2) {
        return _onClick2.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick2.toString();
      };

      return onClick;
    }(e => {
      e.stopPropagation();
      onClick(bundle.id);
      onRemove(bundle.id);
    })
  }, "Remove")));
}